import axios from "axios";

if (process.env.NODE_ENV == "development") {
  axios.defaults.baseURL = "https://app.gztv.com:7443";
}

if (process.env.NODE_ENV == "production") {
  axios.defaults.baseURL = "https://app.gztv.com:7443";
}

// 设置超出时间
axios.defaults.timeout = 5000;

// 请求拦截
// axios.interceptors.request.use(config => {
//   config.headers = {
//     Authorization: ""
//   };
//   return config;
// });

// 封装get方法  并抛出
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 封装post方法  并抛出
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

// 封装post方法  并抛出
export function postForm(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        }
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
